const rbacActions = {
    VIEW: "VIEW",
    EDIT: "EDIT",
    SAVE: "SAVE",
    DELETE: "DELETE",
}

export default rbacActions